var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.renderVideo)?_c('video',{ref:"videoPlayer",staticClass:"z-0 w-full h-full",attrs:{"controls":"","autoplay":""}},[_c('source',{attrs:{"src":_vm.fileUrl,"type":_vm.item.mimeType}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }